import { atom } from "recoil";

const photoValidationState = atom({
  key: "photoValidation",
  default: { isValid: "noPhoto" },
});

export default photoValidationState;
